import PropTypes from 'prop-types'
import { CustomInputWrapper } from '../../styled'
import { OptionLabel } from '../styles'

function ChooseInput({ question, value, onChange }) {
  const optionsObj = question.answer?.options || {}
  const options = Object.keys(optionsObj)
  const selected = value || []

  const toggle = (label) => {
    const next = selected.includes(label)
      ? selected.filter((l) => l !== label)
      : [...selected, label]
    onChange(next)
  }

  return (
    <div className="mt-2">
      {options.map((label) => (
        <CustomInputWrapper
          key={label}
          checked={selected.includes(label)}
          onClick={() => toggle(label)}
        >
          <input
            type="checkbox"
            checked={selected.includes(label)}
            onChange={() => toggle(label)}
          />
          <OptionLabel>{label}</OptionLabel>
        </CustomInputWrapper>
      ))}
    </div>
  )
}

ChooseInput.propTypes = {
  question: PropTypes.shape({
    answer: PropTypes.shape({
      options: PropTypes.objectOf(PropTypes.string),
    }),
  }).isRequired,
  value: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func.isRequired,
}

export default ChooseInput
